import gsap from "gsap";

import ScrollTrigger from "gsap/ScrollTrigger";


import isIpadPro from "./helpers/isIpad";
gsap.registerPlugin(ScrollTrigger);
const gsapRunAll = () => {
    smallAddOnParallax();
    heroAnimations();
    darkOnScrollHeaderFixed();
    fadeInText();
    fadeInHeading();
    fadeInUp();
    fadeInDown();
    vehicleGridAnimate();
}
export default gsapRunAll;

const fadeInText = () =>{
    if(document.querySelector('.fade-in')){
        const allFadeIns = document.querySelectorAll('.fade-in');
        let ipad = isIpadPro();
        allFadeIns.forEach(fade =>{
            if(fade.closest('.stoof-hero-wrapper') || fade.classList.contains('is-heading') || ipad){
                return;
            }
            let timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: fade,
                    end: 'top center',
                    toggleActions: 'restart pause revert reset',
                    //markers: true,
                    scrub: 1,
                }

            })
            timeline.fromTo(fade, {autoAlpha: 0}, {autoAlpha: 1, duration: 1.2 });
        })

    }
}
const fadeInHeading = () =>{
    if(document.querySelector('.is-heading')){
        const allFadeIns = document.querySelectorAll('.is-heading');
        let ipad = isIpadPro();
        allFadeIns.forEach((fade, index) =>{
            if(fade.closest('.stoof-hero-wrapper') || ipad){
                return;
            }else{
                let timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: fade,
                        start: 'top bottom',
                        end: 'center bottom',
                        toggleActions: 'restart pause revert reset',
                        //markers: true,
                        scrub: 1,
                    }

                })

                timeline.fromTo(fade, {autoAlpha: 0, y: -5}, {autoAlpha: 1, y: 0, duration: 1.2 });
            }

        })

    }
}
const fadeInUp = () =>{
    if(document.querySelector('.fade-in-up')){
        const allFadeIns = document.querySelectorAll('.fade-in-up');
        let ipad = isIpadPro();
        allFadeIns.forEach(fade =>{
            if(fade.closest('.stoof-hero-wrapper') || fade.classList.contains('is-heading') || ipad){
                return;
            }
            let timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: fade,
                    start: 'top bottom',
                    end: 'center bottom',
                    toggleActions: 'restart pause revert reset',
                   // markers: true,
                    scrub: 1,
                }

            })

            timeline.fromTo(fade, {autoAlpha: 0, y: -50}, {autoAlpha: 1, y: 0, duration: 1.2 });
        })

    }
}
const fadeInDown = () =>{
    if(document.querySelector('.fade-in-down')){
        const allFadeIns = document.querySelectorAll('.fade-in-down');
        let ipad = isIpadPro();

        allFadeIns.forEach((fade, index) =>{
            if(fade.closest('.stoof-hero-wrapper') || fade.classList.contains('is-heading') || ipad){
                return;
            }else{
                let timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: fade,
                        start: 'top bottom',
                        end: 'center bottom',
                        toggleActions: 'restart pause revert reset',
                        //markers: true,
                        scrub: 1,
                    }

                })

                timeline.fromTo(fade, {autoAlpha: 0, y: 50}, {autoAlpha: 1, y: 0, duration: 1.2 });
            }

        })

    }
}
const vehicleGridAnimate = () =>{
    if(document.querySelector('.vehicle-grid-animate')){
        const allFadeIns = document.querySelectorAll('.vehicle-grid-animate');
        allFadeIns.forEach(fade =>{
            const allCars = fade.querySelectorAll('.please-bounce-in');
            let timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: fade,
                    start: 'top center',
                    end: 'bottom bottom',
                    toggleActions: 'restart pause revert reset',
                   // markers: true,
                    scrub: 1,
                }

            })
            timeline.fromTo(allCars, {autoAlpha: 0}, {autoAlpha: 1, stagger: 0.8*allCars.length, duration: 1*allCars.length });
        })

    }
}
const smallAddOnParallax = () => {
    if (document.querySelector('.stoof-add-on-background')) {
        //const allBackgrounds = document.querySelectorAll('.stoof-add-on-background');
        let timeline = gsap.timeline({
            scrollTrigger: {
                trigger: '.stoof-add-on-image',
                toggleActions: 'restart pause revert reset',
                //markers: true,
                scrub: 1,
            }

        })
        timeline.fromTo('.stoof-add-on-image', {yPercent: '-=10'}, {yPercent: '+=10'})
        // timeline.to('.stoof-add-on-image',{yPercent: '+=20'})
    }
}

const heroAnimations = () => {
    if (document.querySelector('.stoof-hero-wrapper')) {
        const allHeroWrappers = document.querySelectorAll('.stoof-hero-wrapper');
        allHeroWrappers.forEach((hero, index) => {


            if (index === 0) {
                let loadTl = gsap.timeline({defaults: {ease: 'ease-in', duration: 1}});
                let heroTl = heroAnimation(hero, index);
                heroTl.pause();
                loadTl.add(heroTl.tweenFromTo(0, heroTl.duration()), '0');
                setTimeout(() => {
                    loadTl.add(() => { // after that tween is done, we'll create a ScrollTrigger with the "real" heroTl animation
                        ScrollTrigger.create({
                            animation: heroTl,
                            trigger: hero,
                            toggleActions: 'play reset play reset',
                        });
                    });
                }, 2000)



            } else {
                let loadTl = gsap.timeline({defaults: {ease: 'ease-in', duration: 1}});

                let heroTl = heroAnimation(hero, index);

                heroTl.pause();
                loadTl.add(() => { // after that tween is done, we'll create a ScrollTrigger with the "real" heroTl animation

                    ScrollTrigger.create({
                        animation: heroTl,
                        trigger: hero,
                        toggleActions: 'play reset play reset',
                    });
                });

            }


            function heroAnimation(parent, index) {

                const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
                let image = parent.querySelector('.stoof-hero-image');
                let heading = parent.querySelector('.is-heading');
                let preParagraphs = Array.from(parent.querySelectorAll('p:not(.is-heading)'));
                let paragraphs = [];
                let ipad = isIpadPro();

                preParagraphs.forEach(p => {
                    if(!p.parentElement.classList.contains('acf-label') &&  !p.parentElement.classList.contains('wp-block-stoof-stoof-form-creator-block')){
                        if(vw > 1025 && !ipad){
                            paragraphs.push(p);
                        }

                    }
                })
                let side = parent.querySelector('.stoof-hero-side');
                let buttons = Array.from(parent.querySelectorAll('.wp-block-buttons'));
                let scroller = document.querySelector('.stoof-scroll-to-content-svg');
                let video = parent.querySelector('.stoof-hero-video');

                const tl = gsap.timeline({defaults: {ease: 'ease-in', duration: 1}});

                if (parent.querySelector('.stoof-hero-inner__max-height') === null && parent.querySelector('.stoof-hero-inner__contact') === null) {
                    if (image !== null && video == null) {
                        if(vw > 600 && !ipad){
                            if (parent.classList.contains('stoof-zoom-out')) {
                                if (vw > 1025) {
                                    tl.fromTo(image, {scale: 1.1, y: 0}, {
                                        scale: 1,
                                        x: 5,
                                        y: -15,
                                        duration: 2,
                                        ease: 'sine'
                                    }, 0);
                                } else {
                                    tl.fromTo(image, {scale: 1.1, y: 0}, {
                                        scale: 1,
                                        x: 0,
                                        y: -15,
                                        duration: 2,
                                        ease: 'sine'
                                    }, 0);
                                }

                            } else {
                                tl.fromTo(image, {scale: 1, y: 0}, {scale: 1.1, y: -15, duration: 2, ease: 'sine'}, 0);
                            }
                        }


                    }
                }
                if (heading !== null) {
                    tl.to(heading, {autoAlpha: 1, y: 0, duration: 1, ease: 'sine'}, 0)
                }
                if (scroller !== null && index === 0) {
                    tl.fromTo(scroller, {autoAlpha: 0}, {autoAlpha: 1, y: 0, duration: 1, ease: 'sine'}, 0)
                }
                if (side !== null) {
                    tl.fromTo(side, {autoAlpha: 0}, {autoAlpha: 1, y: 0, duration: 1, ease: 'sine'}, 0)
                }

                if (paragraphs.length > 0) {
                    tl.fromTo(paragraphs, {autoAlpha: 0}, {autoAlpha: 1, duration: 1, ease: 'sine'}, 0)
                }


                if (buttons.length > 0 && vw > 1025 && !ipad) {
                    tl.fromTo(buttons, {autoAlpha: 0}, {autoAlpha: 1, duration: 1, ease: 'sine'}, 0)
                }
                if (video !== null) {

                    tl.add(playTheVideo(video), 1)
                }

                function playTheVideo(video) {
                    video.play();
                }


                return tl;

            }
        })

    }


}

const darkOnScrollHeaderFixed = () => {
    if (document.querySelector('.stoof-position-fixed')) {
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        const scrollDownArrow = document.querySelector('.stoof-scroll-to-content');
        let start = 'center bottom';
        let end = 'center center';
        if(vw > 750 && vw < 1025 && vh > 1023){
            start = 'top-=100px center';
        }
        if(vw < 750){
            start = 'center bottom-=300px';
            end = 'top-=100px top';

        }
        let timeline = gsap.timeline({
            scrollTrigger: {
                trigger: '.stoof-fixed-trigger',
                start: start,
                endTrigger: '.stoof-vehicle-by-category--holder',
                end: end,
                toggleActions: 'restart pause revert reset',
                //markers: true,
                scrub: 1,
                snap:  {
                    snapTo: "labelsDirectional", // snap to the closest label in the timeline
                    duration: {min: 0.2, max: 3}, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
                    delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snapping

                },
            }

        })


        timeline.addLabel('start');
        timeline.to('.stoof-position-fixed', {duration: 1.5, yPercent: -30}, 0);
        timeline.fromTo('.stoof-position-fixed', {autoAlpha: 1}, {duration: 1, autoAlpha: 0}, 1)
        timeline.fromTo(scrollDownArrow, {autoAlpha: 1}, {duration: 1, autoAlpha: 0}, 1)
        timeline.addLabel('end');
    }
}
